/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import React, { useEffect } from 'react'
import { Input, Form, Row, Col, Select, Radio } from 'antd'
import InputMask from 'react-input-mask'
const { Option } = Select
// const USER_TYPES = ['USER', 'ADMIN']
const USER_STATUS = ['ACTIVE', 'REVOKED', 'LOCKED']

// const USERNAME_SIZE_VALIDATION_MSG = 'maximum 15 characters allowed'
const USERNAME_VALIDATION_MSG = 'User Name already exists'
const PASSWORD_NOT_MATCH_MSG = 'Confirm password does not match'
const PHONE_ISNOT_VALID_MSG = 'Please insert all digits'
// const PHONE_MASK = '(999) 999-9999'
const PHONE_MASK_PLACEHOLDER = '_'
const PHONE_MASK = '(999) 999-9999'

const getValueFromEvent = e => {
  return (e.target.value || '').trim()
}

const UserDetailsForm = props => {
  const {
    userFormRef,
    isNew = true,
    user,
    setUser,
    form,
    userNameList,
    // groups,
    // companyNameMap,
    // stationList,
    // ldapEnabled = false,
    passwordDisabled,
    isLdapUsernameEnabled = false,
  } = props

  const {
    getFieldDecorator,
    getFieldValue,
    validateFields,
    setFieldsValue,
  } = form

  useEffect(() => {
    userFormRef.current = form
    // set form value incase of update, load time only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const validateUserName = (rule, value, callback) => {
    if (userNameList.includes(value)) {
      callback(USERNAME_VALIDATION_MSG)
    }
    callback()
  }

  const validatePhone = (rule, value, callback) => {
    if (value && value.includes(PHONE_MASK_PLACEHOLDER)) {
      callback(PHONE_ISNOT_VALID_MSG)
    }
    callback()
  }

  const compareToFirstPassword = (rule, value, callback) => {
    if (value !== getFieldValue('password')) {
      callback(PASSWORD_NOT_MATCH_MSG)
    } else {
      callback()
    }
  }

  const validateToNextPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['confirmPassword'], { force: true })
      callback()
    }
    callback()
  }

  // const validatePassword = (rule, password, callback) => {
  //   if (!password) callback()
  //   if (password != null && password.trim().length < 6)
  //     callback('Password must be at least 6 digits or letters')
  //   else if (password != null && !password.match(/\s*[0-9]+\s*/))
  //     callback('Password must contain at least 1 number')
  //   else if (password != null && !password.match(/\s*[A-Z]+\s*/))
  //     callback('Password must contain at least 1 upper ase letter')
  //   else if (password != null && !password.match(/\s*[a-z]+\s*/))
  //     callback('Password must contain at least 1 lower case letter')
  //   else validateFields(['confirmPassword'], { force: true })
  //   callback()
  // }

  const updateUser = (property, value) => {
    setUser(user => ({ ...user, [property]: value }))
    setFieldsValue({ [property]: value })
  }

  const style = { marginBottom: '5px' }

  return (
    <div
      style={{
        display: 'grid',
        overflowX: 'hidden',
        overflowY: 'auto',
        height: '90vh',
        width: '900px',
      }}
    >
      <Form layout="vertical">
        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label="User Type">
              <Radio.Group
                optionType="button"
                buttonStyle="solid"
                value={user.userType}
                onChange={e => updateUser('userType', e.target.value)}
              >
                <Radio.Button value="USER">USER</Radio.Button>
                <Radio.Button value="ADMIN">ADMIN</Radio.Button>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          {isNew && (
            <Col span={12}>
              <Form.Item label="User Name :">
                {getFieldDecorator('userName', {
                  initialValue: '',
                  rules: [
                    { required: true, message: 'Please Enter UserName' },
                    { validator: validateUserName },
                  ],
                  getValueFromEvent,
                })(
                  <Input
                    autoFocus
                    placeholder="Enter User Name"
                    name="userName"
                    maxLength={15}
                    onChange={e => {
                      const v = (e.target.value || '').trim()

                      updateUser('userName', v)
                    }}
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
            </Col>
          )}

          <Col span={12}>
            <Form.Item label="Email :" hasFeedback>
              {getFieldDecorator('email', {
                initialValue: user.email || '',
                rules: [
                  {
                    type: 'email',
                    message: 'The input is not valid E-mail!',
                  },
                ],
                getValueFromEvent,
              })(
                <Input
                  style={{ width: '400px' }}
                  placeholder="Enter Email Address"
                  name="email"
                  maxLength={60}
                  onChange={e => updateUser('email', e.target.value)}
                />
              )}
            </Form.Item>
          </Col>

          {!isNew && (
            <Col span={12}>
              <Form.Item label="User Status :">
                <Select
                  style={{ width: '400px' }}
                  name="userStatus"
                  value={
                    user.userStatus
                      ? user.userStatus.toUpperCase()
                      : USER_STATUS.ACTIVE
                  }
                  onChange={val => updateUser('userStatus', val)}
                >
                  {USER_STATUS.map(status => (
                    <Option key={status}>{status}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          )}
        </Row>
        {isLdapUsernameEnabled && (
          <Row>
            <Col span={24}>
              <Form.Item label="LDAP User Name : (If not provided, Username will be used as the default ldap_username)">
                <Input
                  style={{ width: '400px' }}
                  placeholder="LDAP User Name "
                  value={user.userInfo3 || ''}
                  name="userInfo3"
                  maxLength={50}
                  onChange={e => updateUser('userInfo3', e.target.value || '')}
                />
              </Form.Item>
            </Col>
          </Row>
        )}

        {isNew && !passwordDisabled && (
          <Row gutter={12}>
            <Col span={12}>
              <Form.Item label="Temporary Password :">
                {getFieldDecorator('password', {
                  initialValue: '',
                  rules: [
                    { required: true, message: 'Please Enter the Password' },
                    {
                      min: 7,
                      message: 'Password required at least 7 character',
                    },
                    {
                      max: 15,
                      message: 'Max password length is 15 chanracter',
                    },
                    {
                      validator: validateToNextPassword,
                    },
                  ],
                  getValueFromEvent,
                })(
                  <Input.Password
                    style={{ width: '400px' }}
                    placeholder="Enter Temporary Password"
                    name="password"
                    onChange={e =>
                      updateUser('password', (e.target.value || '').trim())
                    }
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Confirm Password :">
                {getFieldDecorator('confirmPassword', {
                  initialValue: '',
                  rules: [
                    {
                      validator: compareToFirstPassword,
                    },
                  ],
                  getValueFromEvent,
                })(
                  <Input.Password
                    style={{ width: '400px' }}
                    placeholder="Confirm Temporary Password"
                    name="confirmPassword"
                    autoComplete="new-password"
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
        )}

        <Row gutter={12}>
          <Col span={12}>
            <Form.Item label="First Name :" style={style}>
              <Input
                style={{ width: '400px' }}
                placeholder="Enter First Name"
                value={user.firstName || ''}
                name="firstName"
                maxLength={25}
                onChange={e => updateUser('firstName', e.target.value || '')}
              />
            </Form.Item>
          </Col>

          <Col span={12}>
            <Form.Item label="Last Name :" style={style}>
              <Input
                style={{ width: '400px' }}
                placeholder="Enter Last Name"
                value={user.lastName || ''}
                name="lastName"
                maxLength={25}
                onChange={e => updateUser('lastName', e.target.value)}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item label="Phone Number" hasFeedback>
              {getFieldDecorator('phone', {
                initialValue: user.phone || '',
                rules: [
                  {
                    validator: validatePhone,
                  },
                ],
              })(
                <InputMask
                  style={{ width: '400px' }}
                  mask={PHONE_MASK}
                  maskPlaceholder={PHONE_MASK_PLACEHOLDER}
                  name="phone"
                  placeholder="Enter phone Number"
                  className="ant-input"
                  onChange={e => updateUser('phone', e.target.value)}
                />
              )}
            </Form.Item>
          </Col>
        </Row>
        {/* <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="Company :" style={style}>
              <Select
                name="companies"
                mode="multiple"
                placeholder="Company"
                value={user.companies || []}
                onChange={val => updateUser('companies', val)}
              >
                {Object.keys(companyNameMap)
                  .map(k => {
                    return { key: k, value: companyNameMap[k] }
                  })
                  .map(item => (
                    <Option key={item.key}>{item.value}</Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
          
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="User Group(s) :" style={style}>
              <Select
                name="groups"
                mode="multiple"
                placeholder="User Group(s)"
                value={user.groups || []}
                onChange={val => updateUser('groups', val)}
              >
                {groups.map(item => (
                  <Option key={item}>{item}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={12}>
          <Col span={24}>
            <Form.Item label="User Station(s) :" style={style}>
              <Select
                name="station"
                mode="multiple"
                placeholder="User Station(s)"
                value={user.stations || []}
                onChange={val => updateUser('stations', val)}
              >
                {stationList.map(item => (
                  <Option key={item.key}>{item.text}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      */}
      </Form>
    </div>
  )
}

export default Form.create({ name: 'user_details' })(UserDetailsForm)

const PasswordReset = props => {
  const { passwordResetFormRef, setPassword, form } = props

  const { getFieldDecorator, getFieldValue, validateFields } = form

  const compareToFirstPassword = (rule, value, callback) => {
    if (value !== getFieldValue('password')) {
      callback(PASSWORD_NOT_MATCH_MSG)
    } else {
      callback()
    }
  }

  const validateToNextPassword = (rule, value, callback) => {
    if (value) {
      validateFields(['confirmPassword'], { force: true })
      callback()
    }
    callback()
  }

  // const validatePassword = (rule, password, callback) => {
  //   if (!password) callback()
  //   if (password != null && password.trim().length < 6)
  //     callback('Password must be at least 6 digits or letters')
  //   else if (password != null && !password.match(/\s*[0-9]+\s*/))
  //     callback('Password must contain at least 1 number')
  //   else if (password != null && !password.match(/\s*[A-Z]+\s*/))
  //     callback('Password must contain at least 1 upper ase letter')
  //   else if (password != null && !password.match(/\s*[a-z]+\s*/))
  //     callback('Password must contain at least 1 lower case letter')
  //   else validateFields(['confirmPassword'], { force: true })
  //   callback()
  // }

  useEffect(() => {
    passwordResetFormRef.current = form
    // set form value incase of update, load time only
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Form layout="vertical">
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item label="Temporary Password :">
            {getFieldDecorator('password', {
              initialValue: '',
              rules: [
                { required: true, message: 'Please Enter the Password' },
                {
                  validator: validateToNextPassword,
                },
              ],
              getValueFromEvent,
            })(
              <Input.Password
                placeholder="Enter Temporary Password"
                name="password"
                onChange={e => setPassword((e.target.value || '').trim())}
              />
            )}
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        <Col span={24}>
          <Form.Item label="Confirm Password :">
            {getFieldDecorator('confirmPassword', {
              initialValue: '',
              rules: [
                {
                  validator: compareToFirstPassword,
                },
              ],
              getValueFromEvent,
            })(
              <Input.Password
                placeholder="Confirm Temporary Password"
                name="confirmPassword"
              />
            )}
          </Form.Item>
        </Col>
      </Row>
    </Form>
  )
}

export const PasswordResetForm = Form.create({ name: 'password_reset' })(
  PasswordReset
)
